import { Box, Typography, Grid, Paper } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

const options = [
  {
    key: "time",
    icon: <AccessTimeIcon sx={{ fontSize: 40 }} />,
    title: "Log Time",
    description: "Record your start and end time for a work session",
  },
  {
    key: "fixed",
    icon: <TaskAltIcon sx={{ fontSize: 40 }} />,
    title: "Log Deliverable",
    description: "Submit a completed deliverable",
  },
];

export default function TypeSelector({ onSelect }) {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        What would you like to log?
      </Typography>
      <Grid container spacing={2}>
        {options.map((opt) => (
          <Grid item xs={12} sm={6} key={opt.key}>
            <Paper
              variant="outlined"
              onClick={() => onSelect(opt.key)}
              sx={{
                p: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1.5,
                cursor: "pointer",
                borderRadius: 3,
                transition: "all 0.15s ease",
                "&:active": { transform: "scale(0.97)" },
                "&:hover": {
                  borderColor: "primary.main",
                  backgroundColor: "action.hover",
                },
              }}
            >
              <Box sx={{ color: "primary.main" }}>{opt.icon}</Box>
              <Typography variant="subtitle1" fontWeight={600}>
                {opt.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" align="center">
                {opt.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
